const Component = () => import('./BestDeals');

// eslint-disable-next-line import/prefer-default-export
export { Component };
